import { RouterProvider } from 'react-router-dom';
import { IMAGE_UPLOAD_RETRY_EVENT_TYPE } from './constants';
import { useEffect } from 'react';
import { Workbox } from 'workbox-window';
import { createAppRouter } from './routes';

const router = createAppRouter();

export default function App() {
    useEffect(() => {
        // Retry image uploads when back online
        // see https://stackoverflow.com/a/55338293/4228052
        if (!('serviceWorker' in navigator)) return;
        const wb = new Workbox('/service-worker.js');
        const onOnline = () => {
            console.log('back online!');
            wb.messageSW({ type: IMAGE_UPLOAD_RETRY_EVENT_TYPE });
        };
        window.addEventListener('online', onOnline);
        return () => window.removeEventListener('online', onOnline);
    }, []);
    return <RouterProvider router={router} />;
}
